import React from "react";

import { ColHead } from './chunk'

class Privacy extends React.Component {

	render() {
		return (
			<div className="col col-2">
      			<ColHead title="Datenschutzerklärung" />
      			<div class="richtext">
      				<p>
      				</p>
      			</div>
		    </div>
      	)
	}
}


export default Privacy


// WEBPACK FOOTER //
// ./src/components/Privacy.js